import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import AlertasMobile from "./AlertasMobile";
import AlertasDesktop from "./AlertasDesktop";

function Alertas({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <AlertasMobile app={app} config={config} />
  ) : (
    <AlertasDesktop app={app} config={config} />
  );
}

Alertas.defaultProps = {
  app: null,
  config: {},
};

Alertas.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Alertas;
